import {UntilDestroy} from '@ngneat/until-destroy';
import {Injectable} from '@angular/core';
import {DcpDataService} from '../dcp-data.service';
import {EddlAdobeTrackingData} from './models/eddl-adobe-tracking-data';
import {CxEvent, EventService} from '@spartacus/core';
import {FormUuidService} from '../form-uuid.service';
import {EddlFormErrorEvent} from './events/eddl-form-error-event';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpEddlFormErrorService extends DcpDataService<EddlAdobeTrackingData> {
  constructor(protected formUuidService: FormUuidService, protected eventService: EventService) {
    super();
  }

  fillData(event: EddlFormErrorEvent, data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }
    if (!data.forms) {
      data.forms = {};
    }
    data.event = 'formError';
    data.forms.uniqueID = this.formUuidService.getTrimmedUuidByFormName(event.name);
    data.forms.name = event.name;
    data.forms.errorDescription = event.errorDescription;
    data.forms.referrer = window.location.href;

    if (!data.ecommerce && event.products?.length > 0) {
      data.ecommerce = {};
      data.ecommerce.products = [];

      data.ecommerce.products.push({
        id: event?.products?.[0]?.ID,
        name: event?.products?.[0]?.name,
        partnerName: event?.products?.[0]?.partnerName,
      });
    }

    return data;
  }

  getData(event: CxEvent): EddlAdobeTrackingData {
    if (!(event instanceof EddlFormErrorEvent)) {
      return undefined;
    }
    return this.fillData(event);
  }
}
